<template>
  <div class="oneYuan">
    <div class="header">
      <div class="wrap-inner">
        <h1 class="fr logo">大智慧</h1>
      </div>
    </div>
    <div class="banner">
      <div class="wrap-inner">
        <span class="btn-price">定价：998/年</span>
        <div class="slogn">
          <img src="../../assets/images/activity/1yuan/pc-slogn.png" width="100%" />
        </div>
        <div class="login">
          <div class="login-wrap">
            <ul class="login-list">
              <li>
                <div class="ipt-wrap">
                  <input type="text" placeholder="姓名" v-model.trim="realName" />
                </div>
              </li>
              <li>
                <div class="ipt-wrap">
                  <input type="text" placeholder="手机号" v-model.number="mobile" />
                </div>
              </li>
            </ul>
            <a href="###" class="login-btn" @click="buy()" :class="selectRules?'':'disabled'">立即购买</a>
          </div>
          <div class="login-rules">
            <input type="checkbox" checked="checkbox" id="cbox" />
            <label for="cbox" @click="selectRules=!selectRules">我已仔细阅读相关协议</label>
            <a href="https://i.gw.com.cn/UserCenter/rulesregister.html" target="_blank">《使用软件许可协议》</a>
          </div>
        </div>
      </div>
    </div>
    <div class="mod mod-org">
      <div class="wrap-inner">
        <h2 class="mod-tit">看懂资金流 把握短线风口</h2>
        <h3 class="mod-tit-sub">LEVEL-2 专业交易所行情</h3>
        <div class="mod-blocks blocks-col2 blocks-vertical">
          <dl class="block-item">
            <dt>SV资金流向</dt>
            <dd>追踪控盘资金在板块、龙头股间流动情况</dd>
            <dd>
              <img src="../../assets/images/activity/1yuan/pc01.png" alt width="100%" />
            </dd>
          </dl>
          <dl class="block-item">
            <dt>DDE资金流</dt>
            <dd>监控主力进出周期的长短,挖掘建仓中的股票。</dd>
            <dd>
              <img src="../../assets/images/activity/1yuan/pc02.png" alt width="100%" />
            </dd>
          </dl>
          <dl class="block-item">
            <dt>龙虎看盘</dt>
            <dd>看懂资金的主动性买卖，读懂当天盘口的奥秘。</dd>
            <dd>
              <img src="../../assets/images/activity/1yuan/pc03.png" alt width="100%" />
            </dd>
          </dl>
          <dl class="block-item">
            <dt>单数差</dt>
            <dd>读懂成交密语，笑看主力意图</dd>
            <dd>
              <img src="../../assets/images/activity/1yuan/pc04.png" alt width="100%" />
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="mod mod-white">
      <div class="wrap-inner">
        <h2 class="mod-tit">题材挖掘 紧跟市场动态</h2>
        <h3 class="mod-tit-sub">筛选炒股策略 简单易操作</h3>
        <div class="mod-blocks blocks-col2 blocks-horizontal">
          <dl class="block-item">
            <dt>大数据掘金</dt>
            <dd>在数据洪流中,迅速反应市场机会</dd>
            <dd class="img">
              <img src="../../assets/images/activity/1yuan/pc05.png" alt width="100%" />
            </dd>
          </dl>
          <dl class="block-item">
            <dt>热点狙击</dt>
            <dd>
              释放热点信号
              <br />助力股市投资
            </dd>
            <dd class="img">
              <img src="../../assets/images/activity/1yuan/pc06.png" alt width="100%" />
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="mod mod-red">
      <div class="wrap-inner">
        <div class="mod-blocks blocks-col3">
          <dl class="block-item">
            <dt>专业LEVE-2行情</dt>
            <dd>
              上证10档行情
              <br />深市全行情
            </dd>
          </dl>
          <dl class="block-item">
            <dt>专业分析策略</dt>
            <dd>
              资金流向深度分析
              <br />市场热点挖掘
            </dd>
          </dl>
          <dl class="block-item">
            <dt>新手易用</dt>
            <dd>
              图形界面一看就懂
              <br />专业客服24小时在线
            </dd>
          </dl>
        </div>
        <img src="../../assets/images/activity/1yuan/pc-slogn2.png" alt class="slogn-buy" />
        <a href="###" class="btn-buy" @click="scroll()">立即购买</a>
      </div>
    </div>
    <div class="mod mod-darkred">
      <div class="wrap-inner">
        <p class="tips">
          购买须知: 大智慧365收费版，1元免费体验，部分特权功能自购买日起30天有效 尽快登录使用哦！
          <br />本活动时间: 4月15日-12月31日
        </p>
        <div class="footer-informs">
          <span>投资有风险 入市需谨慎</span>
          <span>从事证券投资或期货交易，请通过合法证券期货经营机构进行。</span>
          <br />
          <span>合法机构名单可到中国证监会网站（www.csrc.gov.cn）查询</span>
          <span>大智慧股份有限公司对本活动拥有解释权</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      selectRules: true,
      queryParams: "",
      payloadParams: { productId: 116, month: 1 },
      realName: "",
      mobile: ""
    };
  },
  created() {
    var index = window.location.href.indexOf("?");
    if (index > -1) {
      this.queryParams = window.location.href.substring(index);
    }
  },
  methods: {
    buy() {
      if (!this.selectRules) {
        this.$global.alert("请仔细阅读软件使用协议");
        return false;
      }
      if (!this.realName) {
        this.$global.alert("姓名不能为空");
        return false;
      }
      if (this.realName.length > 7) {
        this.$global.alert("姓名长度不能超过7位");
        return false;
      }
      if (!this.$validate.checkChineseWord(this.realName)) {
        this.$global.alert("姓名必须是中文");
        return false;
      }
      if (!this.mobile) {
        this.$global.alert("手机号不能为空");
        return false;
      }
      if (!this.$validate.checkPhone(this.mobile)) {
        this.$global.alert("手机号码格式不正确");
        return false;
      }
      this.payloadParams.realName = this.realName;
      this.payloadParams.mobile = this.mobile;
      this.$post("/activity/oybInit" + this.queryParams, this.payloadParams)
        .then(response => {
          if (response.code === 0) {
            this.$storage.saveUserName(response.data);
            this.$router.push("/order/confirm/116/1");
          } else if (response.code === 1001) {
            this.$storage.saveUserName(response.data.userName);
            this.$router.push("/order/pay/" + response.data.id);
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    scroll() {
      window.scrollTo(0, 400);
    }
  }
};
</script>

<style lang="scss" scoped>
.oneYuan {
  input::-webkit-input-placeholder {
    color: #ccc;
  }
  .wrap-inner {
    max-width: 1200px;
    margin: 0 auto;
    width: 80%;
  }
  .header {
    background: #fff;
    padding: 15px 0 56px;
    h1 {
      background: url("../../assets/images/activity/1yuan/logo.png") no-repeat 0
        0;
      width: 150px;
      height: 47px;
      text-indent: -999px;
      overflow: hidden;
    }
  }
  .banner {
    background: #dc332a;
    .wrap-inner {
      height: 725px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        left: -210px;
        top: -66px;
        background: url("../../assets/images/activity/1yuan/pc-computer.png")
          no-repeat 0 0;
        width: 712px;
        height: 516px;
        background-size: 100% auto;
        -webkit-background-size: 100% auto;
        -ms-background-size: 100% auto;
      }
    }
  }
  .slogn {
    right: 0;
    top: 110px;
    position: absolute;
    width: 680px;
  }
  .btn-price {
    position: absolute;
    right: 0;
    top: 16px;
    background: url("../../assets/images/activity/1yuan/pc-btn.png");
    width: 280px;
    height: 50px;
    font-size: 31px;
    color: #fff;
    text-align: center;
    line-height: 48px;
  }
  .login {
    position: absolute;
    left: 12%;
    width: 76%;
    bottom: -120px;
  }
  .login-wrap {
    background: #fff url("../../assets/images/activity/1yuan/pc08.jpg")
      no-repeat 0 0;
    padding: 36px 36px 36px 408px;
    height: 265px;
    box-shadow: 0 0 112px 10px rgba(0, 0, 0, 0.23);
  }
  .login-list li {
    padding-bottom: 34px;
    position: relative;
    .ipt-wrap {
      border: 2px solid #cecece;
      padding: 12px 15px;
    }
    input {
      display: block;
      width: 100%;
      height: 27px;
      line-height: 27px;
      font-size: 24px;
      color: #333;
    }
    .error {
      position: absolute;
      left: 0;
      bottom: 7px;
      font-size: 16px;
      color: #f6301e;
    }
  }
  .login-btn {
    display: block;
    width: 100%;
    line-height: 86px;
    text-align: center;
    font-size: 34px;
    color: #fff;
    background: #f6301e;
    letter-spacing: 5px;
    &.disabled {
      background: #ccc;
      pointer-events: none;
    }
  }
  .login-rules {
    text-align: center;
    margin: 23px 0 0;
    font-size: 22px;
    position: relative;
    input {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      &:checked + label:after {
        content: "";
        position: absolute;
        left: 0;
        top: 3px;
        background: url("../../assets/images/activity/1yuan/chkbox2.png")
          no-repeat 0 0;
        width: 20px;
        height: 22px;
      }
    }
    label {
      padding-left: 30px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 17px;
        left: 0;
        top: 5px;
        height: 17px;
        border: 2px solid #f6301e;
      }
    }
    a {
      color: #ffcd1e;
    }
  }
  .mod {
    padding-top: 65px;
    &-tit {
      font-size: 60px;
      text-align: center;
      &-sub {
        font-size: 44px;
        margin: 5px 0 60px;
        text-align: center;
      }
    }
  }
  .mod-org {
    background: #ff8a2b;
    padding-top: 180px;
    .mod-tit {
      color: #c71a12;
      &-sub {
        color: #fff;
      }
    }
    .mod-blocks .block-item {
      background: #fff;
    }
  }
  .mod-white {
    .mod-blocks .block-item {
      background: #ff8a2b;
    }
    .blocks-horizontal .block-item {
      height: 262px;
      position: relative;
      dt {
        color: #fff;
      }
    }
    .mod-tit-sub {
      color: #dd2f25;
    }
  }
  .mod-red {
    background: #dd2d1d;
    padding-bottom: 100px;
    .block-item {
      background: #bc130b;
      height: 170px;
      dt {
        padding: 15px 35px 10px;
        color: #fff;
      }
      dd {
        padding: 0 35px;
        color: #fff;
      }
    }
  }
  .mod-darkred {
    background: #921009;
    padding-bottom: 60px;
    .tips {
      color: #fff;
    }
  }
  .mod-blocks {
    overflow: hidden;
    .block-item {
      float: left;
    }
  }
  .blocks-col2 .block-item {
    width: 48%;
    height: 472px;
    margin-bottom: 40px;
    &:nth-of-type(odd) {
      margin-right: 4%;
    }
  }
  .blocks-col2.blocks-horizontal .block-item:nth-of-type(even) {
    dt {
      padding: 35px 20px 10px 380px;
    }
    dd {
      padding: 0 20px 0 380px;
      &.img {
        right: auto;
        left: 28px;
      }
    }
  }
  .blocks-col3 .block-item {
    width: 32%;
  }
  .blocks-col3 .block-item:nth-of-type(3n + 2) {
    margin: 0 2%;
    background: #c51712 url("../../assets/images/activity/1yuan/pc07.png")
      no-repeat right top;
  }
  .blocks-col3 .block-item:nth-of-type(3n + 3) {
    background: #cb2424;
  }
  .blocks-horizontal .block-item {
    dt {
      padding: 35px 380px 10px 20px;
    }
    dd {
      padding: 0 380px 0 20px;
      height: auto;
      &.img {
        padding: 0 !important;
        position: absolute;
        right: 28px;
        top: 50%;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        img {
          margin: 0;
        }
      }
    }
  }
  .block-item {
    dt {
      font-size: 34px;
      padding: 35px 35px 10px;
      color: #dd2f25;
    }
    dd {
      font-size: 24px;
      padding: 0 35px;
      color: #000;
      height: 60px;
      img {
        display: block;
        width: 100%;
        height: auto;
        margin-top: 20px;
      }
    }
  }
  .slogn-buy {
    display: block;
    margin: 60px auto 20px;
    width: 50%;
  }
  .btn-buy {
    display: block;
    width: 34%;
    margin: 0 auto;
    text-align: center;
    font-size: 58px;
    letter-spacing: 5px;
    color: #000;
    background: #fff;
    line-height: 132px;
  }
  .tips {
    font-size: 22px;
  }
  .footer-informs {
    font-size: 22px;
    color: #490707;
    margin-top: 20px;
    span {
      margin-right: 80px;
    }
  }
}
@media screen and (max-width: 1480px) {
  .oneYuan {
    .banner .wrap-inner {
      height: 600px;
      &:before {
        width: 620px;
      }
    }
    .login-rules {
      font-size: 18px;
      label:before {
        top: 0;
      }
      input:checked + label:after {
        top: -2px;
      }
    }
    .slogn {
      width: 500px;
    }
    .slogn-buy {
      width: 40%;
    }
    .btn-buy {
      line-height: 80px;
      font-size: 40px;
    }
    .mod-tit {
      font-size: 48px;
    }
    .mod-tit-sub {
      font-size: 36px;
    }
    .block-item {
      dt {
        font-size: 28px;
      }
      dd {
        font-size: 18px;
      }
    }
    .tips {
      font-size: 14px;
    }
    .footer-informs {
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/OYB116.vue